import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLeftNavComponent } from './app-left-nav.component';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ AppLeftNavComponent ],
  exports: [ AppLeftNavComponent ]
})

export class AppLeftNavModule { }
